import React, { useEffect } from "react";

const CALENDLY_SCRIPT_SRC = "https://assets.calendly.com/assets/external/widget.js";

export default function CalendlyInline({ url, height = 720, className = "" }) {
  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (document.querySelector(`script[src="${CALENDLY_SCRIPT_SRC}"]`)) return undefined;
    const s = document.createElement("script");
    s.src = CALENDLY_SCRIPT_SRC;
    s.async = true;
    document.body.appendChild(s);
    return undefined;
  }, []);

  return (
    <div className={className}>
      <div
        className="calendly-inline-widget"
        data-url={url}
        style={{ minWidth: "320px", height: `${height}px` }}
      />
      <noscript>
        <a href={url} target="_blank" rel="noreferrer">
          Book via Calendly
        </a>
      </noscript>
    </div>
  );
}

